import { defineComponent } from '../c-mp/fun/defineComponent'
import { andrisEmail } from '../fun/andrisEmail'
import { setPageTitle } from '../fun/setPageTitle'
import { _ } from '../model/ccc'

export const PageNotFoundComp = defineComponent<{}>(
	'PageNotFoundComp',
	(props, $) => {
		setPageTitle('Nem található')

		return (
			<div class={_.ccc_page}>
				<h1>Ez az oldal nem található</h1>
				<p>Szerinted ez hiba?</p>
				<p>
					<a
						class={_.ccc_button__rounded}
						href={andrisEmail(
							'Nem található oldal',
							'De ez az oldal nem található. Úgy jutottam ide, hogy...',
						)}
					>
						Jelezd Andrisnak
					</a>
				</p>
			</div>
		)
	},
)
